
export interface UploadKaroakeDto
{
    getClientTxnId():string;
    getServiceId():string;
    getToneFile():any;
    getToneName():string;
    getAPartyMsisdn():string;
    getIscopy():string;
    getChannelId():string;
    getLanguage():string;
    getPriority():string;
}

export class UploadKaroakeDtoImpl implements UploadKaroakeDto
{
    private clientTxnId: string;
    private serviceId: string;
    private toneFile: any;
    private toneName: string;
    private aPartyMsisdn: string;
    private isCopy: string;
    private channelId: string;
    private language: string;
    private priority: string;

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string
    {
        return this.clientTxnId;
    }

    setServiceId(serviceId: string)
    {
        this.serviceId = serviceId;
    }
    getServiceId(): string
    {
        return this.serviceId;
    }

    setToneFile(toneFile: any)
    {
        this.toneFile = toneFile;
    }
    getToneFile(): any
    {
        return this.toneFile;
    }

    setToneName(toneName: string)
    {
        this.toneName = toneName;
    }
    getToneName(): string
    {
        return this.toneName;
    }

    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }
    getAPartyMsisdn(): string
    {
        return this.aPartyMsisdn;
    }

    setIscopy(isCopy: string)
    {
        this.isCopy = isCopy;
    }
    getIscopy(): string
    {
        return this.isCopy;
    }

    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }
    getChannelId(): string
    {
        return this.channelId;
    }

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string
    {
        return this.language;
    }

    setPriority(priority: string)
    {
        this.priority = priority;
    }
    getPriority(): string
    {
        return this.priority;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/uploadkaroake/uploadkaroakedto.ts